import { render, staticRenderFns } from "./PrescriptionFilter.vue?vue&type=template&id=134b1e74"
import script from "./PrescriptionFilter.vue?vue&type=script&lang=js"
export * from "./PrescriptionFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports